<template>
  <div class="flex flex-wrap gap-y-6 flex-grow">
    <div class="mr-5 sm:mr-13">
      <img
        :src="props.hub.logoUrl"
        class="h-26 w-26 sm:w-46 sm:h-46 rounded-full object-cover"
        alt="Hub logo"
      />
    </div>
    <div class="flex-1 flex flex-col justify-center">
      <h1 class="font-bold text-2xl sm:text-3xl text-on-background">
        {{ props.hub.title }}
      </h1>
      <div class="text-on-background-variant hidden sm:block">
        {{ props.hub.description }}
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { HubDto } from '~/api/hubs';

const props = defineProps<{ hub: HubDto }>();
</script>
